module.exports = __webpack_public_path__ + "img/supervision.687b471e.jpg";